module.exports = __webpack_public_path__ + "media/images/common/logo_bg_07-ded7710229d7825cece9cb5e3dff57cc.png";